// =============================================================================
// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// =============================================================================
// Generated by: npx tsx scripts/generate-icon-registry.ts
// Generated at: 2026-09-02T19:19:30.440Z
// Total icons: 179
// =============================================================================

import type { Icon } from "@tabler/icons-react";
import {
  IconQuestionMark,
  IconAdjustments,
  IconAlertCircle,
  IconAlertOctagon,
  IconAlertTriangle,
  IconApi,
  IconArrowDownRight,
  IconArrowLeft,
  IconArrowUp,
  IconArrowUpRight,
  IconArrowsExchange,
  IconArrowsSort,
  IconArrowsUpDown,
  IconAtom,
  IconAward,
  IconBatteryCharging,
  IconBike,
  IconBlocks,
  IconBolt,
  IconBrandAws,
  IconBrandAzure,
  IconBrandGoogleDrive,
  IconBrandSlack,
  IconBriefcase,
  IconBrowser,
  IconBrush,
  IconBuilding,
  IconBuildingBank,
  IconBuildingCommunity,
  IconBuildingSkyscraper,
  IconBuildingWarehouse,
  IconBulb,
  IconBus,
  IconCalculator,
  IconCalendar,
  IconCalendarEvent,
  IconCalendarMinus,
  IconCalendarStats,
  IconCalendarTime,
  IconCamera,
  IconCarGarage,
  IconCarOff,
  IconCash,
  IconChartBar,
  IconCheck,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconChevronUp,
  IconCircle,
  IconCircleCheck,
  IconCirclePlus,
  IconClipboardCheck,
  IconClock,
  IconClockPlus,
  IconCloud,
  IconCloudDownload,
  IconCloudFog,
  IconCloudRain,
  IconCloudSnow,
  IconCloudStorm,
  IconCode,
  IconCoins,
  IconCopy,
  IconCreditCard,
  IconCurrencyDollar,
  IconDashboard,
  IconDatabase,
  IconDatabaseImport,
  IconDeviceDesktop,
  IconDeviceTv,
  IconDoor,
  IconDoorEnter,
  IconDots,
  IconDownload,
  IconDroplet,
  IconEdit,
  IconEngine,
  IconEye,
  IconFile,
  IconFileText,
  IconFileUpload,
  IconFilter,
  IconFirstAidKit,
  IconFlame,
  IconFolder,
  IconForms,
  IconFrame,
  IconGasStation,
  IconGauge,
  IconGlassFull,
  IconGlobe,
  IconGridPattern,
  IconGripHorizontal,
  IconGripVertical,
  IconHash,
  IconHeart,
  IconHeartRateMonitor,
  IconHelpCircle,
  IconHome,
  IconInfoCircle,
  IconKey,
  IconLayout,
  IconLeaf,
  IconLink,
  IconList,
  IconListCheck,
  IconListDetails,
  IconLoader,
  IconLoader2,
  IconLock,
  IconLogout,
  IconMail,
  IconMapPin,
  IconMapPin2,
  IconMapPinCog,
  IconMapPinPlus,
  IconMaximize,
  IconMessage,
  IconMinimize,
  IconMoodPuzzled,
  IconMoon,
  IconMotorbike,
  IconPackage,
  IconPackages,
  IconPalette,
  IconParking,
  IconParkingCircle,
  IconParkingOff,
  IconPercentage,
  IconPhone,
  IconPhoto,
  IconPlayerPause,
  IconPlayerPlay,
  IconPlaylist,
  IconPlus,
  IconQrcode,
  IconRadio,
  IconRefresh,
  IconReload,
  IconRepeat,
  IconReportMoney,
  IconRoad,
  IconRotateClockwise2,
  IconSearch,
  IconSelector,
  IconSend,
  IconSettings,
  IconShield,
  IconShieldCheck,
  IconShirt,
  IconShoppingCart,
  IconSignature,
  IconSnowflake,
  IconSquare,
  IconSquareCheck,
  IconSticker,
  IconSun,
  IconTag,
  IconTemperature,
  IconTemplate,
  IconThumbDown,
  IconThumbUp,
  IconToggleLeft,
  IconTool,
  IconTrash,
  IconTrendingDown,
  IconTrendingUp,
  IconUpload,
  IconUser,
  IconUserCircle,
  IconUserEdit,
  IconUserPlus,
  IconUsers,
  IconVideo,
  IconWallet,
  IconWebhook,
  IconWheel,
  IconWind,
  IconX
} from "@tabler/icons-react";

/**
 * Registry of icons used in the application.
 *
 * This includes:
 * - Icons detected by scanning <AppIcon iconName="..." /> in source code
 * - Icons manually specified in scripts/icons.config.ts
 *
 * To add new icons:
 * 1. Use them in code with <AppIcon iconName="CirclePlus" /> where "CirclePlus" is an example name of a new icon
 * 2. Or add to manualIcons in scripts/icons.config.ts
 * 3. Run: npm run icons
 */
export const IconRegistry: Record<string, Icon> = {
  "Adjustments": IconAdjustments,
  "AlertCircle": IconAlertCircle,
  "AlertOctagon": IconAlertOctagon,
  "AlertTriangle": IconAlertTriangle,
  "Api": IconApi,
  "ArrowDownRight": IconArrowDownRight,
  "ArrowLeft": IconArrowLeft,
  "ArrowUp": IconArrowUp,
  "ArrowUpRight": IconArrowUpRight,
  "ArrowsExchange": IconArrowsExchange,
  "ArrowsSort": IconArrowsSort,
  "ArrowsUpDown": IconArrowsUpDown,
  "Atom": IconAtom,
  "Award": IconAward,
  "BatteryCharging": IconBatteryCharging,
  "Bike": IconBike,
  "Blocks": IconBlocks,
  "Bolt": IconBolt,
  "BrandAws": IconBrandAws,
  "BrandAzure": IconBrandAzure,
  "BrandGoogleDrive": IconBrandGoogleDrive,
  "BrandSlack": IconBrandSlack,
  "Briefcase": IconBriefcase,
  "Browser": IconBrowser,
  "Brush": IconBrush,
  "Building": IconBuilding,
  "BuildingBank": IconBuildingBank,
  "BuildingCommunity": IconBuildingCommunity,
  "BuildingSkyscraper": IconBuildingSkyscraper,
  "BuildingWarehouse": IconBuildingWarehouse,
  "Bulb": IconBulb,
  "Bus": IconBus,
  "Calculator": IconCalculator,
  "Calendar": IconCalendar,
  "CalendarEvent": IconCalendarEvent,
  "CalendarMinus": IconCalendarMinus,
  "CalendarStats": IconCalendarStats,
  "CalendarTime": IconCalendarTime,
  "Camera": IconCamera,
  "CarGarage": IconCarGarage,
  "CarOff": IconCarOff,
  "Cash": IconCash,
  "ChartBar": IconChartBar,
  "Check": IconCheck,
  "ChevronDown": IconChevronDown,
  "ChevronLeft": IconChevronLeft,
  "ChevronRight": IconChevronRight,
  "ChevronUp": IconChevronUp,
  "Circle": IconCircle,
  "CircleCheck": IconCircleCheck,
  "CirclePlus": IconCirclePlus,
  "ClipboardCheck": IconClipboardCheck,
  "Clock": IconClock,
  "ClockPlus": IconClockPlus,
  "Cloud": IconCloud,
  "CloudDownload": IconCloudDownload,
  "CloudFog": IconCloudFog,
  "CloudRain": IconCloudRain,
  "CloudSnow": IconCloudSnow,
  "CloudStorm": IconCloudStorm,
  "Code": IconCode,
  "Coins": IconCoins,
  "Copy": IconCopy,
  "CreditCard": IconCreditCard,
  "CurrencyDollar": IconCurrencyDollar,
  "Dashboard": IconDashboard,
  "Database": IconDatabase,
  "DatabaseImport": IconDatabaseImport,
  "DeviceDesktop": IconDeviceDesktop,
  "DeviceTv": IconDeviceTv,
  "Door": IconDoor,
  "DoorEnter": IconDoorEnter,
  "Dots": IconDots,
  "Download": IconDownload,
  "Droplet": IconDroplet,
  "Edit": IconEdit,
  "Engine": IconEngine,
  "Eye": IconEye,
  "File": IconFile,
  "FileText": IconFileText,
  "FileUpload": IconFileUpload,
  "Filter": IconFilter,
  "FirstAidKit": IconFirstAidKit,
  "Flame": IconFlame,
  "Folder": IconFolder,
  "Forms": IconForms,
  "Frame": IconFrame,
  "GasStation": IconGasStation,
  "Gauge": IconGauge,
  "GlassFull": IconGlassFull,
  "Globe": IconGlobe,
  "GridPattern": IconGridPattern,
  "GripHorizontal": IconGripHorizontal,
  "GripVertical": IconGripVertical,
  "Hash": IconHash,
  "Heart": IconHeart,
  "HeartRateMonitor": IconHeartRateMonitor,
  "HelpCircle": IconHelpCircle,
  "Home": IconHome,
  "InfoCircle": IconInfoCircle,
  "Key": IconKey,
  "Layout": IconLayout,
  "Leaf": IconLeaf,
  "Link": IconLink,
  "List": IconList,
  "ListCheck": IconListCheck,
  "ListDetails": IconListDetails,
  "Loader": IconLoader,
  "Loader2": IconLoader2,
  "Lock": IconLock,
  "Logout": IconLogout,
  "Mail": IconMail,
  "MapPin": IconMapPin,
  "MapPin2": IconMapPin2,
  "MapPinCog": IconMapPinCog,
  "MapPinPlus": IconMapPinPlus,
  "Maximize": IconMaximize,
  "Message": IconMessage,
  "Minimize": IconMinimize,
  "MoodPuzzled": IconMoodPuzzled,
  "Moon": IconMoon,
  "Motorbike": IconMotorbike,
  "Package": IconPackage,
  "Packages": IconPackages,
  "Palette": IconPalette,
  "Parking": IconParking,
  "ParkingCircle": IconParkingCircle,
  "ParkingOff": IconParkingOff,
  "Percentage": IconPercentage,
  "Phone": IconPhone,
  "Photo": IconPhoto,
  "PlayerPause": IconPlayerPause,
  "PlayerPlay": IconPlayerPlay,
  "Playlist": IconPlaylist,
  "Plus": IconPlus,
  "Qrcode": IconQrcode,
  "Radio": IconRadio,
  "Refresh": IconRefresh,
  "Reload": IconReload,
  "Repeat": IconRepeat,
  "ReportMoney": IconReportMoney,
  "Road": IconRoad,
  "RotateClockwise2": IconRotateClockwise2,
  "Search": IconSearch,
  "Selector": IconSelector,
  "Send": IconSend,
  "Settings": IconSettings,
  "Shield": IconShield,
  "ShieldCheck": IconShieldCheck,
  "Shirt": IconShirt,
  "ShoppingCart": IconShoppingCart,
  "Signature": IconSignature,
  "Snowflake": IconSnowflake,
  "Square": IconSquare,
  "SquareCheck": IconSquareCheck,
  "Sticker": IconSticker,
  "Sun": IconSun,
  "Tag": IconTag,
  "Temperature": IconTemperature,
  "Template": IconTemplate,
  "ThumbDown": IconThumbDown,
  "ThumbUp": IconThumbUp,
  "ToggleLeft": IconToggleLeft,
  "Tool": IconTool,
  "Trash": IconTrash,
  "TrendingDown": IconTrendingDown,
  "TrendingUp": IconTrendingUp,
  "Upload": IconUpload,
  "User": IconUser,
  "UserCircle": IconUserCircle,
  "UserEdit": IconUserEdit,
  "UserPlus": IconUserPlus,
  "Users": IconUsers,
  "Video": IconVideo,
  "Wallet": IconWallet,
  "Webhook": IconWebhook,
  "Wheel": IconWheel,
  "Wind": IconWind,
  "X": IconX,
};

/**
 * Fallback icon shown when requested icon doesn't exist
 */
export const FallbackIcon = IconQuestionMark;

/**
 * Check if an icon exists in the registry
 */
export function hasIcon(name: string): boolean {
  return name in IconRegistry;
}

/**
 * Get an icon from the registry (with fallback)
 */
export function getIcon(name: string): Icon {
  return IconRegistry[name] || FallbackIcon;
}

/**
 * List of all available icon names
 */
export const availableIcons: string[] = [
  "Adjustments",
  "AlertCircle",
  "AlertOctagon",
  "AlertTriangle",
  "Api",
  "ArrowDownRight",
  "ArrowLeft",
  "ArrowUp",
  "ArrowUpRight",
  "ArrowsExchange",
  "ArrowsSort",
  "ArrowsUpDown",
  "Atom",
  "Award",
  "BatteryCharging",
  "Bike",
  "Blocks",
  "Bolt",
  "BrandAws",
  "BrandAzure",
  "BrandGoogleDrive",
  "BrandSlack",
  "Briefcase",
  "Browser",
  "Brush",
  "Building",
  "BuildingBank",
  "BuildingCommunity",
  "BuildingSkyscraper",
  "BuildingWarehouse",
  "Bulb",
  "Bus",
  "Calculator",
  "Calendar",
  "CalendarEvent",
  "CalendarMinus",
  "CalendarStats",
  "CalendarTime",
  "Camera",
  "CarGarage",
  "CarOff",
  "Cash",
  "ChartBar",
  "Check",
  "ChevronDown",
  "ChevronLeft",
  "ChevronRight",
  "ChevronUp",
  "Circle",
  "CircleCheck",
  "CirclePlus",
  "ClipboardCheck",
  "Clock",
  "ClockPlus",
  "Cloud",
  "CloudDownload",
  "CloudFog",
  "CloudRain",
  "CloudSnow",
  "CloudStorm",
  "Code",
  "Coins",
  "Copy",
  "CreditCard",
  "CurrencyDollar",
  "Dashboard",
  "Database",
  "DatabaseImport",
  "DeviceDesktop",
  "DeviceTv",
  "Door",
  "DoorEnter",
  "Dots",
  "Download",
  "Droplet",
  "Edit",
  "Engine",
  "Eye",
  "File",
  "FileText",
  "FileUpload",
  "Filter",
  "FirstAidKit",
  "Flame",
  "Folder",
  "Forms",
  "Frame",
  "GasStation",
  "Gauge",
  "GlassFull",
  "Globe",
  "GridPattern",
  "GripHorizontal",
  "GripVertical",
  "Hash",
  "Heart",
  "HeartRateMonitor",
  "HelpCircle",
  "Home",
  "InfoCircle",
  "Key",
  "Layout",
  "Leaf",
  "Link",
  "List",
  "ListCheck",
  "ListDetails",
  "Loader",
  "Loader2",
  "Lock",
  "Logout",
  "Mail",
  "MapPin",
  "MapPin2",
  "MapPinCog",
  "MapPinPlus",
  "Maximize",
  "Message",
  "Minimize",
  "MoodPuzzled",
  "Moon",
  "Motorbike",
  "Package",
  "Packages",
  "Palette",
  "Parking",
  "ParkingCircle",
  "ParkingOff",
  "Percentage",
  "Phone",
  "Photo",
  "PlayerPause",
  "PlayerPlay",
  "Playlist",
  "Plus",
  "Qrcode",
  "Radio",
  "Refresh",
  "Reload",
  "Repeat",
  "ReportMoney",
  "Road",
  "RotateClockwise2",
  "Search",
  "Selector",
  "Send",
  "Settings",
  "Shield",
  "ShieldCheck",
  "Shirt",
  "ShoppingCart",
  "Signature",
  "Snowflake",
  "Square",
  "SquareCheck",
  "Sticker",
  "Sun",
  "Tag",
  "Temperature",
  "Template",
  "ThumbDown",
  "ThumbUp",
  "ToggleLeft",
  "Tool",
  "Trash",
  "TrendingDown",
  "TrendingUp",
  "Upload",
  "User",
  "UserCircle",
  "UserEdit",
  "UserPlus",
  "Users",
  "Video",
  "Wallet",
  "Webhook",
  "Wheel",
  "Wind",
  "X"
];
